import React, { useState, useRef, useEffect } from 'react';
import { MultipleSelect } from './styles.js';
import { Icon, Checkbox } from 'antd';

const CheckboxGroup = Checkbox.Group;


const DropDown = ({ addColumn, keyDataSet ,defaultSelectedColumns}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [checkedList, setCheckedList] = useState(defaultSelectedColumns);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const onChange = list => {
    if(list.length >=1){
      setCheckedList(list);
      addColumn(list);
    }
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <MultipleSelect ref={dropdownRef}>
      <div className="dropdown-icon" onClick={toggleDropdown}>
        <span>
          <Icon type="ellipsis" />
        </span>
      </div>
      {isDropdownOpen && (
        <div className="dropdown-list">
          <div className="list-desc">Include columns in the tables</div>
          <CheckboxGroup options={keyDataSet} value={checkedList} onChange={onChange} />
        </div>
      )}
    </MultipleSelect>
  );
};

export default DropDown;
